// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.handle-zSrIJa{background-color:var(--coz-stroke-primary);width:1px}.hot-zone-NbMbuF:hover .handle-zSrIJa,.handle-moving-q29tyh{background-color:var(--coz-stroke-hglt);width:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"handle": `handle-zSrIJa`,
	"hot-zone": `hot-zone-NbMbuF`,
	"hotZone": `hot-zone-NbMbuF`,
	"handle-moving": `handle-moving-q29tyh`,
	"handleMoving": `handle-moving-q29tyh`
};
export default ___CSS_LOADER_EXPORT___;
